(() => {
  const init = () => document.querySelectorAll('[data-fs60-specs]').forEach(panel => {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const art = panel.querySelector('svg');
    const rotor = art.querySelector('[data-product-rotor]');
    const disk = art.querySelector('[data-product-spin-disk]');
    const hub = art.querySelector('[data-product-hub-sharp]');
    const hubBlur = art.querySelector('[data-product-hub-blur]');
    const bars = [...panel.querySelectorAll('.fs-bar i')];
    const counters = [...panel.querySelectorAll('[data-fs-count]')];
    const format = new Intl.NumberFormat('en-US');
    let running = false, entered = false, frame, generation = 0;
    const finish = () => {
      generation++;
      cancelAnimationFrame(frame);
      counters.forEach(el => el.textContent = format.format(Number(el.dataset.fsCount)));
      bars.forEach(bar => bar.style.transform = 'scaleX(1)');
      rotor.removeAttribute('transform');rotor.style.opacity = '1';rotor.style.filter = 'none';
      disk.setAttribute('opacity', '0');hub.removeAttribute('transform');hub.setAttribute('opacity', '1');hubBlur.setAttribute('opacity', '0');
      running = false;delete panel.dataset.fsRunning;
    };
    const animate = async (force = false) => {
      if (force) finish();
      if (running) return;
      if (motion.matches && !force) {finish();return;}
      running = true;panel.dataset.fsRunning = 'true';
      const run = ++generation;
      await Promise.all([...new Set([...art.querySelectorAll('image')].map(el => el.getAttribute('href')))].map(async src => {
        const image = new Image();image.src = src;
        try {await image.decode();} catch { /* Keep counters and bars available on image load failure. */ }
      }));
      if (generation !== run) return;
      if ((motion.matches && !force) || !panel.isConnected) {finish();return;}
      panel.classList.add('fs-animating');
      const cx = art.dataset.rotorCx, cy = art.dataset.rotorCy;
      const start = performance.now();
      const tick = now => {
        if (generation !== run) return;
        const progress = Math.min(1, (now - start) / 2600);
        counters.forEach(el => el.textContent = format.format(Math.round(Number(el.dataset.fsCount) * (1 - (1 - progress) ** 3))));
        bars.forEach(bar => bar.style.transform = `scaleX(${progress})`);
        const rampEnd = .4, coastEnd = .72, braking = 1 - coastEnd;
        let speed, travel;
        if (progress < rampEnd) {speed = (progress / rampEnd) ** 2;travel = progress ** 3 / (3 * rampEnd ** 2);}
        else if (progress < coastEnd) {speed = 1;travel = rampEnd / 3 + progress - rampEnd;}
        else {speed = ((1 - progress) / braking) ** 2;travel = rampEnd / 3 + coastEnd - rampEnd + braking / 3 * (1 - ((1 - progress) / braking) ** 3);}
        const phase = travel / (rampEnd / 3 + coastEnd - rampEnd + braking / 3);
        const blend = Math.max(0, Math.min(1, (speed - .18) / .72));
        const strength = blend * blend * (3 - 2 * blend);
        const rotation = `rotate(${21600 * phase} ${cx} ${cy})`;
        rotor.setAttribute('transform', rotation);rotor.style.opacity = String(1 - strength);rotor.style.filter = `blur(${strength * 2}px)`;
        disk.setAttribute('opacity', String(strength));hub.setAttribute('transform', rotation);hub.setAttribute('opacity', String(1 - strength));hubBlur.setAttribute('opacity', String(strength));
        if (progress < 1) frame = requestAnimationFrame(tick); else finish();
      };
      frame = requestAnimationFrame(tick);
    };
    window.TytoAnimationReplay?.mount(art.closest('.fs-model__image'), () => animate(true));
    motion.addEventListener('change', () => {if (motion.matches) finish();});
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) entered = false;
        if (entry.intersectionRatio >= .4 && !entered && !running) {entered = true;animate();}
      }), {threshold: [0, .4]});
      observer.observe(panel);
    } else animate();
    if (motion.matches) finish();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
